import './accreditations.scss';
import * as React from 'react';
import useAccreditations from '../../hooks/staticQueries/home/useAccreditations';
import { LinkWrapper } from '../linkWrapper';
import { LazyCosmosImage } from '../media/cosmosImage';
export const Accreditations = () => {
    const accreditations = useAccreditations();
    return (<div className="accreditations">
      {accreditations.map((accreditation) => (<LinkWrapper to={accreditation.url} key={accreditation.title}>
          <div className="accreditation">
            <LazyCosmosImage ticket={accreditation.logo?.[0].ticket} alt={accreditation.title}/>
          </div>
        </LinkWrapper>))}
    </div>);
};
